// extracted by mini-css-extract-plugin
export default {"categoryStructureFramework":"TripTypesFramework_categoryStructureFramework__OWiFl","heading":"TripTypesFramework_heading__AIt98","tripGrid":"TripTypesFramework_tripGrid__z-yWi"};